import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ItemContentsMobile } from './ItemContents';
import { ItemRecipientMobile } from './ItemRecipient';
import { P2GText } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GAlert } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { GetCollatedCustomerReferenceNumbers } from './OrderReferenceNumberUtils';

interface props {
  item: SmartSendItemApiModel;
  cancel: () => void;
  isReturn: boolean;
}

export default function SmartSendItemProcessingMobile(props: props) {
  const refs = GetCollatedCustomerReferenceNumbers(props.item.MarketplaceOrderLines);
  return (
    <P2GBox p={1}>
      <P2GBox p={1} display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
        <P2GText variant="subtitle2" component="div" flexGrow={1}>
          {refs}
        </P2GText>
        <P2GCheckBoxLegacy
          onChange={() => {}}
          checked={props.item.State.selected}
          disabled
          labelPlacement="start"
          id="ready"
          variant="primary"
          error={false}
        />
      </P2GBox>
      <P2GBox p={1} backgroundColour="#f1f1f1">
        <ItemRecipientMobile customer={props.isReturn ? props.item.Sender : props.item.Recipient} />
      </P2GBox>
      <P2GBox p={1}>
        <ItemContentsMobile item={props.item} />
      </P2GBox>
      <P2GBox p={1}>
        <P2GAlert color="info">
          <P2GText variant="body2">You have started to pay for this externally...</P2GText>
          <P2GLinkGroup
            pb={0}
            pt={0}
            links={[
              <P2GLink key="release" onClick={props.cancel}>
                Release
              </P2GLink>
            ]}
          />
        </P2GAlert>
      </P2GBox>
    </P2GBox>
  );
}
